var _defs, _path, _circle, _circle2, _circle3, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCc(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: 512,
    width: 512,
    id: "flag-icon-css-cc",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M0-360l69.42 215.845 212.04-80.3L155.987-35.604l194.986 115.71-225.88 19.65 31.104 224.592L0 160l-156.198 164.35 31.105-224.592-225.88-19.65 194.985-115.71-125.47-188.854 212.037 80.3z",
    id: "a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-210L54.86-75.508l144.862 10.614L88.765 28.842l34.67 141.052L0 93.334l-123.435 76.56 34.67-141.052-110.957-93.736L-54.86-75.508z",
    id: "b"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "green",
    d: "M0 0h512v512H0z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 268.22,
    cy: 250.446,
    r: 61.243,
    fill: "#ffe000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 287.316,
    cy: 250.446,
    r: 50.394,
    fill: "green"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.159,
    cy: 189.203,
    r: 64.159,
    fill: "#ffe000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.732 237.58h16.02s.724-1.47-.16-2.204c-.885-.734-4.33-.896-3.4-3.493 1.914-5.34 2.18-3.694 3.383-16.376 1.2-12.683 1.78-32.575 1.78-32.575H86.04s.446 6.185-.89 14.24c-1.334 8.055-1.735 8.767-3.203 14.952-1.47 6.186-1.69 6.72-3.026 10.325-1.334 3.603-1.468 3.78-3.56 7.12-2.09 3.336-1.334 2.09-2.49 4.093-.58 1-1.292.734-1.68 1.463-.39.728-.458 2.453-.458 2.453z",
    fill: "#802000",
    stroke: "#7b3100",
    strokeWidth: 1.361
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.957 142.46c.134 2.488-.117 5.783-1.148 8.463-1.047 2.988-2.184 5.965-2.127 9.06-1.663.564-3.376-3.598-4.976-1.15 1.203 3.385 3.98 6.064 5.883 9.112.32.946 3.058 3.414 1.474 3.988-3.998-1.37-4.967-6.434-7.447-9.51-2.88-5.177-8.25-8.836-14.232-9.09-2.247.06-9.552-.556-7.652 3.292 2.8 1.903 6.25 3.144 9.014 5.28 2.06.193 5.792 3.63 5.574 4.93-3.62-1.467-5.316-3.225-9.22-4.77-5.287-2.04-12.6-.812-15.528 4.436-.546 1.367-1.352 5.35.365 5.73 2.005-3.13 4.874-6.63 9.125-5.692 3.34.26-3.726 6.22-1.024 5.02.857-.38 2.834-1.677 4.206-1.813 1.372-.135 2.138.892 3.178 1.034 2.082.283 2.655 1.155 2.462 1.663-.227.6-.89.088-3.005.76-1.06.334-1.61 1.264-2.846 1.69-1.234.425-3.8.455-4.76.078-3.357-1.457-8.86-1.203-9.906 3.003 0 1.85-1.647-.205-2.407.594-.57 2.02-.717 4.09-3.71 3.908-1.818 1.906-3.68 3.88-5.986 5.236 1.354 3.11 6.72-3.12 6.468-.493-2.345 3.198 1.207 3.87 2.762 1.41 2.63-2.78 5.887-6.162 9.81-3.362 1.87 1.76 2.956-.93 4.31-.786.85 2.185 1.923.107 2.89-.51 1.584-.2 1.14 1.977 3.02.637 3.75-2.482 8.364-.397 12.027-2.81 3.9-1.778.55 1.43-.528 2.683-1.713 3.323-.227 7.685-3.943 9.75-1.494 3.96 1.762 9.18-1.56 12.11-.482 1.836 4.273 1.626 5.607 2.38 2.338.093-.1-5.35 2.22-6.08 3.11 1.925 2.965-3.445 2.323-5.1.3-3.766.514-7.883 2.385-11.293 1.99-4.18 3.83 1.702 1.603 3.357-1.264 3.843-3.106 8.653-.23 12.227.83.187 1.51 2.196 2.583 2.813 1.074.618 2.54-.156 2.808-1.984 1.376-5.505.683-11.424 2.648-16.777 1.388-1.66 3.302-.268 4.162 1.257 2.755 3.198 4.692 7.196 8.027 9.832 3.036 1.42 5.722 3.57 7.12 6.696-.017 2.412 6.852 2.782 4.8.1-1.97-2.61-.67-5.22 1.324-6.955 1.067.263.752-1.65-.086-.893-1.34-.317-1.427-2.772.437-1.605 3.14 1.014-.243-2.272-1.378-2.373-2.655-1.646-5.706-3.54-7.01-6.4 3.455.036 7.043 1.9 10.575.743 2.83-1.454 5.702.122 6.69 2.617 2.19-.35 1.256-2.544 0-3.275 1.6-.66 2.708-2.03.768-3.238-1.025-1.338 1.374-3.62-1.575-3.525.096-2.253-.79-4.314-3.247-5.093-2.46-2.083-9.68 3.07-9.47-1.626-.727-2.556 2.933-.342 3.956-1.617 1.055-2.695-5.037-2.432-3.027-4.52 1.313-.846 7.475-2.06 2.643-2.965-2.412.663-4.482.172-6.38-1.022-1.73 2.894-6.668-1.57-5.788 3.573-.676 1.938-5.09 6.974-6.286 3.116 1.016-3.024 6.247-4.013 4.625-8.09-.25-2.545-2.36.443-3.353.253-.504-1.584 1.522-3.452 2.934-3.828 2.802 2.155 2.887-2.72 5.552-2.322 1.945-.432-.628-1.267-1.17-1.633.532-1.424 3.52-2.152.59-3.388-2.584-1.918-4.5 1.908-6.63 2.112-2.046-2.31 1.857-3.42 2.934-4.636.058-.906-2.276-.273-1.574-1.063.61-1.09 4.743-1.17 2.807-2.807-2.914-1-6.674-.75-9.47.545-1.762.57-2.28 4.554-3.8 4.39-.713-1.774.233-5.272-2.21-5.785zm13.78 38.915c2.22-.376.047 3.372-1.02 3.317.094-1.347-3.212-1.217-1.16-2.39a6.685 6.685 0 0 1 2.18-.927z",
    fill: "green"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-25.746 103.463) scale(.05833)",
    fill: "#ffe000"
  }, /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 7560,
    y: 4200
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 6300,
    y: 2205
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 7560,
    y: 840
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#a",
    x: 8680,
    y: 1869
  }), /*#__PURE__*/React.createElement("use", {
    height: "100%",
    width: "100%",
    xlinkHref: "#b",
    x: 8064,
    y: 2730
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCc);
export default __webpack_public_path__ + "static/media/cc.bc89abfd5c276fc2db7b0396c891bc88.svg";
export { ForwardRef as ReactComponent };